import { Box, Button, Checkbox, Divider, Stack, Tab, Tabs } from '@mui/material';
import { ReactElement, ReactNode } from 'react';
import { Outlet, Route, Routes, Link, useLocation } from 'react-router-dom';

export type NavTabInfo = {
  path: string;
  label: string;
  icon?: ReactElement;
  component: ReactNode;
  disabled?: boolean;
}

interface NavTabsProps {
  tabs: NavTabInfo[];
  checkedItems: number[];
  isAllChecked: boolean;
  isIndeterminate: boolean;
  countElements: number;
  handleToggleAll: (e: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
  handleMarkAsDone: () => void;
  renderActions?: (args: { checkedItems: number[]; isAllChecked: boolean; isIndeterminate: boolean; countElements: number }) => ReactNode;
  hideHeaderCheckbox?: boolean;
}

export const NavTabs = ({ 
  tabs,
  checkedItems,
  isAllChecked,
  isIndeterminate,
  countElements,
  handleToggleAll,
  handleMarkAsDone,
  renderActions,
  hideHeaderCheckbox = false,
}: NavTabsProps) => {
  const location = useLocation();
  const tabName = location.pathname.split('/').at(-1);
  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Tabs value={tabName} variant="scrollable" scrollButtons="auto">
          {tabs.map(({ path, label, icon, disabled }, i) => {
            return <Tab
              key={i}
              label={label}
              value={path}
              iconPosition="start"
              icon={icon}
              to={path}
              component={Link}
              disabled={disabled}
            />;
          })}
        </Tabs>
        <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 2, marginBottom: 0 }}>
          {!hideHeaderCheckbox && (
            <Checkbox
              onChange={handleToggleAll}
              checked={isAllChecked}
              indeterminate={isIndeterminate}
              disabled={countElements === 0}
            />
          )}
          {renderActions ? (
            renderActions({ checkedItems, isAllChecked, isIndeterminate, countElements })
          ) : (
            <Button variant="contained" size="small" disabled={checkedItems.length === 0} onClick={handleMarkAsDone}>
              Выполнено
            </Button>
          )}
        </Stack>
      </Box>

      <Divider />
      <Routes>
        <Route element={<Outlet />}>
          {tabs.map(({ path, component }) => (
            <Route key={path} path={path} element={component} />
          ))}
        </Route>
      </Routes>
    </>
  );
};
